import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";
export interface BxPrintingDistributionRoutes
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BxPrintingDistributionRoutes[];
}
export const bxPrintingDistributionRoutes: BxPrintingDistributionRoutes[] = [
  {
    path: "/bx/printing-distribution",
    element: <Landing />,
  },
  {
    path: "/bx/printing-distribution/:tab",
    element: <Landing />,
  },
  {
    path: "/bx/printing-distribution/:tab",
    element: <Landing />,
  },
  {
    path: "/bx/printing-distribution/consumers/:id",
    element: <Landing />,
  },
];
